export default __webpack_public_path__ + "static/media/pattern.b2b4db33.svg";